import classNames from 'classnames';
import PropTypes from 'prop-types';

import { trans } from '@spotahome/soyuz/client';

import FileUploadInitial from '../../icons/FileUploadInitial';
import Button from '../../Button';

import { useThemeFlag } from '../../../../base/ThemeProvider';

import styles from '../FileUploader.module.scss';

const cx = classNames.bind(styles);

const Uploading = ({ className }) => {
  const newButtonsEnabled = useThemeFlag('newButtons');

  const fileUploaderClasses = cx(
    styles['file-uploader'],
    styles['file-uploader--is-working'],
    className
  );

  const fileUploaderButtonClasses = cx(styles['file-uploader__button'], {
    [styles['file-uploader__button--rebranding']]: newButtonsEnabled
  });

  return (
    <div data-cy="fileUploaderUploadingState" className={fileUploaderClasses}>
      <div className={styles['file-uploader__content']}>
        <div>
          <FileUploadInitial className={styles['file-uploader__icon']} />
        </div>
        <div className={styles['file-uploader__title']}>
          {trans('document-upload.loading')}
          <span className={styles['file-uploader__loading-dot-one']}>.</span>
          <span className={styles['file-uploader__loading-dot-two']}>.</span>
          <span className={styles['file-uploader__loading-dot-three']}>.</span>
        </div>
      </div>
      <div>
        <Button disabled className={fileUploaderButtonClasses}>
          {trans('loading')}
        </Button>
      </div>
    </div>
  );
};

Uploading.propTypes = {
  className: PropTypes.string.isRequired
};

export default Uploading;
